// extracted by mini-css-extract-plugin
module.exports = {"component":"UserManagementScreen_component__tclgZ"};